import { type Filters } from '../hooks/useFilters'

const arrayFilterKeys = [
  'planIds',
  'taskIds',
  'subPlanIds',
  'productIds',
  'matrixIds',
  'sampntTypeIds',
  'purposeIds',
  'subPurposeIds',
  'sampleIds',
  'substanceIds',
  'status'
] as const

const scalarFilterKeys = [
  'result',
  'regionId',
  'avdelingId',
  'seksjonId',
  'teamId',
  'userId',
  'sampleId',
  'searchText',
  'producerSearch',
  'labId',
  'fromDate',
  'toDate'
] as const

export const getFilterCount = <T extends string>(filters: Filters<T>) => {
  const orgFieldSet =
    filters.regionId != null ||
    filters.avdelingId != null ||
    filters.seksjonId != null ||
    filters.teamId != null

  const ownerIdCount =
    !orgFieldSet && filters.ownerId != null && filters.ownerId.length !== 0
      ? 1
      : 0

  return (
    arrayFilterKeys.reduce(
      (count, key) => count + (filters[key]?.length ?? 0),
      0
    ) +
    scalarFilterKeys.reduce(
      (count, key) =>
        count + (filters[key] != null && filters[key]?.length !== 0 ? 1 : 0),
      0
    ) +
    ownerIdCount
  )
}

const getEmptyFilters = <T extends string>(): Filters<T> => ({
  productIds: [],
  sampntTypeIds: [],
  purposeIds: [],
  subPurposeIds: [],
  substanceIds: [],
  planIds: [],
  taskIds: [],
  subPlanIds: [],
  matrixIds: [],
  sampleIds: [],
  status: [],
  result: undefined,
  ownerId: undefined,
  regionId: undefined,
  avdelingId: undefined,
  seksjonId: undefined,
  teamId: undefined,
  userId: undefined,
  sampleId: undefined,
  searchText: undefined,
  producerSearch: undefined,
  labId: undefined,
  fromDate: undefined,
  toDate: undefined
})

export const getEmptySampleFilters = getEmptyFilters

export const getEmptyTaskFilters = getEmptyFilters
